/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const CasesStatsResponse = zod
	.object({
		period: zod.number().describe('Cases in the period'),
		timeseries: zod.array(
			zod
				.object({
					compliant: zod.number().describe('Cases that passed compliance'),
					total_cases: zod.number().describe('Total moderation cases'),
					ts: zod.iso.datetime({ offset: true }).describe('Bucket timestamp'),
					violations: zod.number().describe('Cases flagged as violations')
				})
				.describe('Moderation timeseries data point')
		),
		total: zod.number().describe('All-time cases')
	})
	.describe('Case stats with period\/total counts and timeseries');

export type CasesStatsResponse = zod.input<typeof CasesStatsResponse>;
export type CasesStatsResponseOutput = zod.output<typeof CasesStatsResponse>;
